import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class Sender
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.senders[0];
* const sender = new Sender(record);
* @property {STRING} _id - The id of the sender
* @property {STRING} _name - The name of the sender
*/
export default class Sender extends BCMSRecord {
    _id;
    _name;

    constructor(record) {     
      super(record) 
    }
  }
  Sender.define({
    "recordType":"senders",
    "recordIDProp":"id",
    "className" : "Sender",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id 
       * @property set {NUMBER} - sets the id 
       * @memberof Sender
       */
      BCMSRecordProperty.mapToString("id","_id"),
      /** 
       * @name name
       * @instance
       * @property get {STRING} - gets the name
       * @property set {STRING} - sets the name
       * @memberof Sender
       */
      BCMSRecordProperty.mapToString("name","_name"),

    ]  
})




